/**
 * Studio-only area: a client (role `client`) is sent to the portal instead.
 * Wraps the studio layout, inside ProtectedRoute.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/hooks';

import { isClientRole, PORTAL_HOME } from './portalRole';

export function StudioOnly({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (isClientRole(user?.role)) return <Navigate to={PORTAL_HOME} replace />;
  return <>{children}</>;
}
